import React, { ReactNode } from "react";
import { Box, Paper, Tooltip, IconButton, Typography, styled } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface ICardContainerProps {
  title: string;
  tooltip?: string;
  children?: ReactNode;
  [x: string]: any;
}

const BorderedCard = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 20
}));

const CardContainer: React.FC<ICardContainerProps> = ({ title, tooltip, children, ...styleProps }) => {
  return (
    <BorderedCard elevation={1} sx={{ border: "1px solid divider", m: { sm: 2, lg: 4 }, ...styleProps }}>

      <Box display="flex" flexDirection="column" p={{ xs: 2, sm: 5, md: 8 }} sx={{ alignItems: "center" }} >
        <Box display="flex" alignItems="center" mb={1}>
          <Typography
            variant="h4"
          >
            {title}
          </Typography>
          {tooltip && (
            <Tooltip title={tooltip}>
              <IconButton aria-label="info">
                <InfoIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Box display="flex" alignItems="center" mb={2} mt={{md:2}} sx={{ width: "100%" }}>
          {children}
        </Box>
      </Box>
    </BorderedCard>

  );
};

export default CardContainer;
